import randomId from 'random-id';
import { bngPaymentRef, bngPaymentType } from './consts';

export default function (editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;
  const bngPaymentBtnId = 'png-payment-item' + randomId(8, '');

  if (options.blocks.indexOf(bngPaymentRef) >= 0) {
    bm.add(bngPaymentRef, {
      label: `
      <i class="wb webconnect-wallet2"></i><div>${options.labelBNGPayment}</div>`,
      category: options.labelBNGPaymentCategory,
      content: `
        <button id="${bngPaymentBtnId}" class="${pfx} btn btn-outline-primary btn-sm mx-2"
        data-gjs-type="${bngPaymentType}"
        data-gjs="${bngPaymentType}"
        data-gjs-custom-name="${options.labelBNGPayment}">Buy now</button>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>`,
    });
  }
}
